<template lang="pug">
	.mes
		.semana(
			v-for="(semana, s) in semanas"
			:key="semana.numero"
			:style="{minHeight: altoCelda + 'px'}"
		)
			div(
				style="position: absolute; display: flex; left: 0; top: 0; right: 0; bottom: 0;"
			)
				.dia(
					v-for="(dia, d) in semana.dias"
					:key="dia.diaStr"
					:class="dia.dia.getMonth() !== fecha.getMonth() ? 'disabled' : dia.hoy ? 'hoy' : ''"
				)
					template(v-if="s === 0")
						div.mb-0.text-center(style="font-weight: bold;") {{dias[d]}}
					div.m-0.text-center
						span {{ dia.dia.getDate() }}
						span.ml-2(style="opacity: 0.7", v-if="dia.hoy") (hoy)

			// Eventos
			div(
				style="position: absolute; display: flex; left: 0; top: 0; right: 0; bottom: 0;margin-top: 30px;background-color: rgba(0,0,0,0.1);"
			)
				.diaEvento(
					v-for="(dia, d) in semana.dias"
					:key="dia.diaStr + '-ev'"
				)
</template>

<script>
export default {
	props: ['fecha', 'eventos'],
	data () {
		return {
			inicioMes: null,		// Inicio real del mes
			inicioCalendario: null, // Día inicial del calendario
			finCalendario: null,	// Dia final del calendario
			finMes: null,			// Fin real del mes
			semanas: [],
			dias: ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'],
			altoCelda: '60px'
		}
	},
	created () {
		this.construyeMes()
	},
	mounted () {
		window.addEventListener('resize', this.calculaAlto)
		this.calculaAlto()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.calculaAlto)
	},
	watch: {
		fecha: function (newVal) {
			this.construyeMes()
		}
	},
	methods: {
		calculaAlto () {
			const altoVentana = window.innerHeight
			this.altoCelda = altoVentana / 7
		},
		construyeMes () {
			if (!this.fecha) {
				return
			}

			// Calculamos la fecha de inicio de mes
			this.inicioMes = new Date(this.fecha.getTime())
			this.inicioMes.setDate(1)

			// Calculamos el día de la semana en la que empieza el mes
			const diaSemanaInicio = this.inicioMes.getDay() === 0 ? 6 : this.inicioMes.getDay() - 1

			this.inicioCalendario = new Date(this.inicioMes.getFullYear(), this.inicioMes.getMonth(), 1 - diaSemanaInicio, 0, 0, 0, 0)

			// Calculamos la fecha de fin de mes
			this.finMes = new Date(this.inicioMes.getFullYear(), this.inicioMes.getMonth() + 1, 0)

			// Calculamos el día de la semana en la que termina el mes
			const diaSemanaFin = this.finMes.getDay() === 0 ? 6 : this.finMes.getDay() - 1

			this.finCalendario = new Date(this.finMes.getFullYear(), this.finMes.getMonth(), this.finMes.getDate() + 6 - diaSemanaFin, 23, 59, 59, 999)

			// Ahora construímos las semanas teniendo en cuenta el offset del inicio de semana
			let diaActual = this.inicioCalendario
			this.semanas = []
			let semana = {
				dias: [],
				numero: this.getWeek(diaActual),
				eventos: [],
				inicio: new Date(diaActual),
				inicioStr: this.$moment(diaActual).format('YYYYMMDD'),
				fin: new Date(diaActual),
				finStr: this.$moment(diaActual).format('YYYYMMDD')
			}
			while (diaActual <= this.finCalendario) {
				if (diaActual.getDay() === 1 && diaActual !== this.inicioCalendario) {
					this.semanas.push(semana)
					semana = {
						dias: [],
						eventos: [],
						numero: this.getWeek(diaActual),
						inicio: new Date(diaActual),
						inicioStr: this.$moment(diaActual).format('YYYYMMDD'),
						fin: new Date(diaActual),
						finStr: this.$moment(diaActual).format('YYYYMMDD')
					}
				}

				semana.dias.push({
					dia: new Date(diaActual.getTime()),
					diaStr: this.$moment(diaActual).format('YYYYMMDD'),
					hoy: this.$moment().format('YYYYMMDD') === this.$moment(diaActual).format('YYYYMMDD')
				})

				semana.fin = new Date(diaActual)
				semana.finStr = this.$moment(semana.fin).format('YYYYMMDD')
				diaActual = new Date(diaActual.getFullYear(), diaActual.getMonth(), diaActual.getDate() + 1)
			}

			semana.inicioStr = this.$moment(semana.inicio).format('YYYYMMDD')
			semana.finStr = this.$moment(semana.fin).format('YYYYMMDD')
			this.semanas.push(semana)
			this._reparteEventos()
		},
		_reparteEventos () {
			for (let i = 0; i < this.eventos.length; i++) {
				const ev = this.eventos[i]
				const inicioStr = this.$moment(ev.inicio).format('YYYYMMDD')
				const finStr = this.$moment(ev.fin).format('YYYYMMDD')

				const evento = {
					left: 0,
					diaInicio: 0,
					titulo: ev.titulo,
					inicio: ev.inicio,
					fin: ev.fin,
					descripcion: ev.descripcion
				}
				for (let s = 0; s < this.semanas.length; s++) {
					const sem = this.semanas[s]
					let duracionDias = 0
					let dentro = false

					for (let d = 0; d < sem.dias.length; d++) {
						const dia = sem.dias[d]

						if (
							(sem.inicioStr <= inicioStr && sem.finStr >= inicioStr) ||
							(sem.inicioStr <= finStr && sem.finStr >= finStr) ||
							(sem.inicioStr >= inicioStr && sem.finStr <= finStr)
						) {
							// Está dentro de esta semana
							if (dia.diaStr >= inicioStr && dia.diaStr <= finStr) {
								if (!dentro) {
									console.log('El evento entra en el día ' + dia.diaStr + ': ' + d)
									evento.left = parseInt(14 * d)
									evento.diaInicio = d + 1
									dentro = true
									console.log(evento)
								}
								duracionDias++
								evento.width = 14 * duracionDias
							}
						} else {
							console.log('No está entre ' + sem.inicioStr + ' y ' + sem.finStr)
						}
					}

					if (dentro) {
						const obj = JSON.parse(JSON.stringify(evento))
						obj.inicio = new Date(evento.inicio)
						obj.fin = new Date(evento.fin)
						this.semanas[s].eventos.push(obj)
					}
				}
			}
		},
		estiloEvento (evento) {
			const offset = evento.diaInicio * 2
			// const marginLeft = evento.diaInicio * 3 + evento.diaInicio + 3
			const left = (evento.diaInicio - 1) * 14
			return {
				width: 'calc(' + evento.width + '% + ' + offset + 'px)',
				padding: '3px',
				marginLeft: left + '%'
			}
		},
		getWeek (date) {
			var onejan = new Date(date.getFullYear(), 0, 1)
			return Math.ceil((((date - onejan) / 86400000) + onejan.getDay() + 1) / 7)
		}
	}
}
</script>

<style scoped>
.mes {
	border-left: #dadce0 1px solid;
	border-top: #dadce0 1px solid;
}
.nombres {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
	border-top: #dadce0 1px solid;
}

.nombreDiaSemana {
	display: block;
	flex: 1 1 0%;
	border-right: #dadce0 1px solid;
	line-height: 30px;
}

.semana {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
	border-bottom: #dadce0 1px solid;
}
.capaEventos {
	position: relative;
	display: flex;
	flex-direction: row;
}
.dia {
	display: block;
	flex: 1 1 0%;
	border-right: #dadce0 1px solid;
	line-height: 30px;
}

.disabled {
	background-color: #f9f9f9;
}

.hoy {
	background-color: #f0f0f9;
}

.eventoLargo {
	position: relative;
	display: inline-block;
	background-color: darkblue;
	color: white;
	border-radius: 3px;
	margin-left: 3px;
	margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/overview/mes.component.vue